// @core/api/endpoints/attachment/get_download_urls_bulk.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetDownloadUrlsBulkRequest,
  GetDownloadUrlsBulkResponse,
} from '../../../types/attachment';

const BASE_PATH = '/attachment';

/**
 * Get presigned download URLs for multiple attachments
 * Generates presigned download URLs for multiple attachments in a single request. Returns a map of attachment IDs to URLs, with separate lists for failed IDs and errors.
 */
export async function GetDownloadUrlsBulk(
  data: GetDownloadUrlsBulkRequest,
  options?: RequestOptions
): Promise<GetDownloadUrlsBulkResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/attachments/download-urls`;
  const requestOptions = options;
  return client.post<GetDownloadUrlsBulkResponse>(requestPath, data, requestOptions);
}
